var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("위탁안내")])]), _c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-20 mb-md-40"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("위탁 절차")])]), _c('div', {
    staticClass: "my-n10 my-md-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "py-10 py-md-0"
  }, [_c('div', {
    staticClass: "mb-14 mb-md-24",
    staticStyle: {
      "height": "58px"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "56",
      "height": "56",
      "src": "/images/sub/how-to/how-to-consignment-icon.png"
    }
  })], 1), _c('div', [_c('v-divider', {
    staticClass: "primary v-divider--dot my-16"
  }), _c('p', {
    staticClass: "font-size-14 font-size-md-16 font-weight-bold primary--text mb-4"
  }, [_vm._v("STEP 1")]), _c('h5', {
    staticClass: "tit tit--xs font-weight-regular"
  }, [_vm._v("위탁신청 접수")])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "py-10 py-md-0"
  }, [_c('div', {
    staticClass: "mb-14 mb-md-24",
    staticStyle: {
      "height": "58px"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "56",
      "height": "56",
      "src": "/images/sub/how-to/how-to-consignment-icon2.png"
    }
  })], 1), _c('div', [_c('v-divider', {
    staticClass: "primary v-divider--dot my-16"
  }), _c('p', {
    staticClass: "font-size-14 font-size-md-16 font-weight-bold primary--text mb-4"
  }, [_vm._v("STEP 2")]), _c('h5', {
    staticClass: "tit tit--xs font-weight-regular"
  }, [_vm._v("심의 및 감정")])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "py-10 py-md-0"
  }, [_c('div', {
    staticClass: "mb-14 mb-md-24",
    staticStyle: {
      "height": "58px"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "58",
      "height": "58",
      "src": "/images/sub/how-to/how-to-consignment-icon3.png"
    }
  })], 1), _c('div', [_c('v-divider', {
    staticClass: "primary v-divider--dot my-16"
  }), _c('p', {
    staticClass: "font-size-14 font-size-md-16 font-weight-bold primary--text mb-4"
  }, [_vm._v("STEP 3")]), _c('h5', {
    staticClass: "tit tit--xs font-weight-regular"
  }, [_vm._v("위탁계약 체결 및 출품")])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "py-10 py-md-0"
  }, [_c('div', {
    staticClass: "mb-14 mb-md-24",
    staticStyle: {
      "height": "58px"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "56",
      "height": "56",
      "src": "/images/sub/how-to/how-to-consignment-icon4.png"
    }
  })], 1), _c('div', [_c('v-divider', {
    staticClass: "primary v-divider--dot my-16"
  }), _c('p', {
    staticClass: "font-size-14 font-size-md-16 font-weight-bold primary--text mb-4"
  }, [_vm._v("STEP 4")]), _c('h5', {
    staticClass: "tit tit--xs font-weight-regular"
  }, [_vm._v("경매결과 통보 및 대금정산")])], 1)])])], 1)], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("위탁신청 접수")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("이메일 접수")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("작품에 대한 상세한 정보와 이미지를 이메일로 보내주시면 개별 답변을 드립니다.")]), _c('p', {
    staticClass: "page-text primary--text"
  }, [_vm._v("contact@kataauction.com")])]), _c('div', {
    staticClass: "mt-10 mt-md-14"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "h-100",
    attrs: {
      "tile": "",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-16 px-md-30 py-md-20"
  }, [_c('p', {
    staticClass: "page-text primary--text"
  }, [_vm._v("메일 제목 : 작품위탁_고객님 성함")])])])], 1), _c('v-col', {
    staticClass: "mt-n1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "h-100",
    attrs: {
      "tile": "",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-16 px-md-30 py-md-20"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "page-text primary--text"
  }, [_vm._v("메일 내용")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("1. 고객님 성함")]), _c('p', [_vm._v("2. 연락처")]), _c('p', [_vm._v("3. 작품정보 (작가명/작품명/제작연도/크기/재질)")])])]), _c('v-col', {
    staticClass: "mt-n16 mt-md-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("4. 소장경위")]), _c('p', [_vm._v("5. 작품사진"), _c('br'), _vm._v("(전체 이미지, 서명 등 중요부분 이미지)")])])])], 1)], 1)])], 1)], 1)], 1)]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("홈페이지 접수")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("작가의 작품위탁: 작가의 작품위탁은 갤러리를 통하여 접수받고 있습니다. 갤러리에 포트폴리오를 제출하십시오.")])]), _c('div', {
    staticClass: "mt-10 mt-md-14"
  }, [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("회원가입/로그인 후 이용 가능합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v(" 입력해주신 연락처로 개별 답변을 드립니다. "), _c('div', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    staticClass: "pa-0 v-btn--none-active-bg",
    attrs: {
      "small": "",
      "text": "",
      "height": "auto",
      "color": "grey-68",
      "to": "/form/consignment-sale"
    }
  }, [_c('strong', [_vm._v("위탁 신청 하기")]), _c('v-icon', [_vm._v("mdi-menu-right")])], 1)], 1)])])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("우편접수")])]), _c('div', [_c('p', {
    staticClass: "page-text primary--text"
  }, [_vm._v("(우) 03021 서울 종로구 부암동 185-6, 캐터옥션 경매담당자앞 ")])]), _c('div', {
    staticClass: "mt-10 mt-md-14"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("보내실 내용은 위의 이메일 접수 내용과 동일합니다. 봉투에 ‘위탁신청’이라고 표기해 주십시오."), _c('br'), _vm._v("우편으로 접수된 사진은 반송되지 않습니다.")])])])])], 1)], 1)]), _c('v-divider', {
    staticClass: "primary"
  }), _c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("심의 및 감정")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("서면 심의")])]), _c('div', [_c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("1. 심의 항목")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text",
    staticStyle: {
      "letter-spacing": "-.04em!important"
    }
  }, [_vm._v("작품성, 작품상태, 판매가능성, 작품가치, 판매대상 범위와의 부합성 등 다양한 측면을 고려하여 서면심의를 진행합니다")])])], 1)], 1), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("2. 심의 기간")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("접수일로부터 7일 이내 심의를 완료합니다")])])], 1)], 1), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("3. 심의 결과 안내")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("위탁신청 접수 내용을 토대로 심의 후, 위탁 가능 여부를 위탁자에게 개별 안내해 드립니다")])])], 1)], 1)])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("실물 감정")])]), _c('div', [_c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("1. 작품 운송")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("서면심의를 거친 작품에 한해, 실물을 캐터옥션에 입고합니다 (위탁자가 운송)")])])], 1)], 1), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("2. 실물 감정")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("당사에 입고된 작품을 전문가를 통해 실물감정 후 최종으로 출품여부를 결정합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("캐터옥션은 작품의 새로운 가치를 발굴하고자 노력합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("경매 불가 작품은 의뢰인에게 다시 보내 드립니다. (운송비 의뢰인 부담, 방문 회수 시 제외)")])])])])], 1)], 1), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("3. 출품가 결정"), _c('br'), _vm._v("(가격 감정)")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("실물 감정을 통과한 작품에 한해 위탁자와 담당자 간의 출품가( 내정가 )를 결정합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("출품가는 작품이 진품이며, 자유롭게 판매될 수 있음을 전제로 산출합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("작품의 내정가는 의뢰자와 합의 하에 결정되며, 합의가 되지 않을 경우 출품되지 않습니다.")])])])])], 1)], 1)])])])], 1)], 1)]), _c('v-divider', {
    staticClass: "primary"
  }), _c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("위탁계약 체결 및 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("출품")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("위탁 계약 체결")])]), _c('div', [_c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("1. 계약 체결")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("출품가격 결정 후 위탁계약서를 작성합니다")])])], 1)], 1), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("2. 출품 시기")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("출품 시기를 확정하여 출품 전 위탁자에게 출품 확인합니다")])])], 1)], 1)])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("전시 출품")])]), _c('div', [_c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("전시 출품 위탁계약 완료 후, 캐터옥션의 책임과 비용으로 출품작을 전시합니다. ")])]), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("1. 오프라인 전시")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("갤러리 라온 (서울시 종로구 부암동 185-6)")])])], 1)], 1), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("2. 온라인 전시")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("캐터옥션 홈페이지")])])], 1)], 1)])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("판촉 활동")])]), _c('div', [_c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("1. 판촉 기간")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("경매 프리뷰 기간 동안에, 해당 옥션에 대한 적극적인 판촉활동을 전개하여, 작품판매를 촉진합니다.")])])], 1)], 1), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("2. 판촉 채널")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("언론보도, 유튜브, 인스타, 네이버(광고), 다음(광고), 블로그 등 다양한 홍보채널을 활용합니다.")])])], 1)], 1)])])])], 1)], 1)]), _c('v-divider', {
    staticClass: "primary"
  }), _c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("경매결과 통보 및 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("대금정산")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("경매결과 통보")])]), _c('div', [_c('div', [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticClass: "font-weight-medium primary--text"
  }, [_vm._v("경매결과 통보")]), _c('p', [_vm._v("낙찰자 : 경매 종료 후, 낙찰자에게 <낙찰통보서>를 이메일로 발송합니다.")]), _c('p', [_vm._v("위탁자 : 경매 종료 후, 위탁자에게 <경매 결과 안내서>를 이메일로 발송합니다.")]), _c('p', [_vm._v("※ 낙찰된 작품에는 소정의 위탁수수료가 부과")])])]), _c('div', {
    staticClass: "mt-14 mt-md-20"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticClass: "font-weight-medium primary--text"
  }, [_vm._v("낙찰대금 납부")]), _c('p', [_vm._v("3억 미만 : 낙찰 후 1주일 이내에 낙찰대금 완납")]), _c('p', [_vm._v("3억 이상 : 낙찰 후 1주일 이내에 50%, 3주 이내에 완납")]), _c('p', [_vm._v("작품인도 : 낙찰대금 완납 후 낙찰자에게 작품 인도")])])]), _c('div', {
    staticClass: "mt-14 mt-md-20"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticClass: "font-weight-medium primary--text"
  }, [_vm._v("위탁대금 지급")]), _c('p', [_vm._v("지급시기 : 낙찰자의 낙찰대금이 완납되면, 위탁자에게는 위탁대금을 지급합니다"), _c('br'), _vm._v("(통상 3억 미만은 1주일 이내, 3억 이상은 3주일 이내 지급 예상)")]), _c('p', [_vm._v("※ 위탁대금 = 낙찰금액 - 위탁수수료(5%, VAT별도) - 기타 비용(발생할 경우)")]), _c('p', [_vm._v("※ 기타비용 : 보험가입, 액자교체, 보존처리, 전문감정 등 고객 요청으로 인해 발생한 비용")])])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("위탁 수수료")])]), _c('div', [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("위탁 수수료 : 낙찰가의 5% (부가세 별도)를 적용합니다.")]), _c('p', [_vm._v("양도세 부과 : 양도가액 6,000만원 이상인 것을 대상으로 합니다. 양도일 현재 생존해 있는 국내 작가의 작품은 제외됩니다.")]), _c('p', [_vm._v("유찰된 작품 : 위탁자가 반출하셔야 합니다 (운송은 위탁자가 진행) ")])])])])])], 1)], 1)])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }